const StemMelodySvg: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8038 22.073C25.6734 16.685 23.4382 12.8021 21.662 10.9659C20.629 9.93089 19.7183 8.77946 18.9478 7.5345L17.5309 5.15657H16.4332V22.083C16.0968 21.8113 15.7059 21.6159 15.2874 21.5103C14.8689 21.4046 14.4326 21.3912 14.0084 21.471C12.9548 21.6491 11.9859 22.1626 11.2443 22.9358C9.56792 24.6215 9.24861 27.0495 10.5458 28.3539C10.8181 28.6186 11.1401 28.8259 11.4931 28.9637C11.8461 29.1016 12.2229 29.1671 12.6014 29.1566C13.865 29.1109 15.0609 28.5709 15.9343 27.6516C16.6972 26.9012 17.2067 25.9292 17.3912 24.8723C17.3961 24.7821 17.3961 24.6916 17.3912 24.6014V6.93249L18.0597 8.0462C18.8635 9.36128 19.818 10.577 20.9036 11.6683C22.6499 13.4743 23.8972 16.4342 20.7639 20.5178L20.8038 22.073Z"
        fill={color || "white"}
      />
      {/* <rect
        x="0.624176"
        y="1.03212"
        width="32.25"
        height="32.25"
        stroke="#8B8B8B"
        stroke-width="0.25"
      /> */}
    </svg>
  );
};

export default StemMelodySvg;
